export const TOGGLE_DEV_BUTTON = 'TOGGLE_DEV_BUTTON';

export const toggleDevButton = () => ({ type: TOGGLE_DEV_BUTTON });

const INITIAL_STATE = {
  showButtons: false,
};

const dev = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TOGGLE_DEV_BUTTON:
      return {
        ...state,
        showButtons: !state.showButtons,
      };
    default:
      return state;
  }
};
export default dev;
